import React from 'react';
import { Header, List } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const CohortQueryStatusPopup = ({ status }) => (
  <>
    <Header as="h6">
      <FormattedMessage id="cohort.query.visualisations.no.tooltip" />
    </Header>
    <List bulleted items={status.show_chart_data.reasons} />
  </>
);

export default CohortQueryStatusPopup;
